import { createSlice } from '@reduxjs/toolkit';
import { gamesFilterSliceProto } from './consts';

export const myGamesFilters = createSlice({
  name: 'myGamesFilters',
  ...gamesFilterSliceProto,
});

export const myGamesFiltersReducer = myGamesFilters.reducer;
